import styles from './PriceBox.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

interface PriceBoxProps {
  price: string;
  subPrice?: string;
  button: JSX.Element;
  className?: string;
}

export default function PriceBox({
  price,
  subPrice,
  button,
  className,
}: PriceBoxProps): JSX.Element {
  return (
    <div className={cx('root', className && className)}>
      <span
        className={styles.price}
      >
        <span dangerouslySetInnerHTML={{ __html: price }} ></span>
        {subPrice && (
          <small
            className={styles.subPrice}
            dangerouslySetInnerHTML={{ __html: subPrice }}
          ></small>
        )}
      </span>
      {button}
      <div></div>
    </div>
  );
}
